// Constants
import { DEFAULT_LOADER_PROPS } from './constants/button.configurations.constants';
// Types
import { IconPositionType, ButtonType } from '@kubit/web-ui-product-components';
const buttonConfigurationPropsConversion = (props) => ({
    children: props?.children,
    disabled: props?.disabled,
    fullWidth: props?.rwdFull,
    icon: props?.iconConfiguration,
    iconPosition: props?.iconPosition ?? IconPositionType.RIGHT,
    id: props?.testId,
    loading: props?.loading,
    onClick: props?.onClick ? props?.onEventClick : undefined,
    size: props.size,
    type: ButtonType.BUTTON,
    variant: props.type,
    loader: props?.loader || DEFAULT_LOADER_PROPS,
});
export { buttonConfigurationPropsConversion };
//# sourceMappingURL=button.configuration.js.map